'use es6';

import { OPEN_SOCIAL_COMPOSER, CLOSE_SOCIAL_COMPOSER } from './actionTypes';
import { getPublishSocialComposerParams } from '../selectors/socialComposerSelectors';
export const openSocialComposer = params => dispatch => {
  dispatch({
    type: OPEN_SOCIAL_COMPOSER,
    payload: params
  });
};

// a workaround to issue where `onGetPostBodySuccess` callback in `BaymaxBlogPublishButtonContainer` sees stale values for `socialComposerOptions`,
// reflecting state on initial page load but not updates after
export const openSocialComposerWithParams = postBody => (dispatch, getState) => {
  const params = getPublishSocialComposerParams(getState());
  dispatch(openSocialComposer({
    blogPost: Object.assign({}, params, {
      postBody
    })
  }));
};
export const closeSocialComposer = () => dispatch => {
  dispatch({
    type: CLOSE_SOCIAL_COMPOSER
  });
};